import {useCallback} from "react";
import {useExportTimeSheets} from "../../api/useExportTimeSheets";
import {useDateFilters} from "../../hooks/useDateFilters";
import { useActionWithAccess } from "../../../../utils/hooks/access";

export const useExport = ({ ids, columns, filters, other = {} }) => {
    const {from, to} = useDateFilters();
    const {downloadWeeklyDetails, downloadWeeklySummary} = useExportTimeSheets();

    const downloadSummary = useActionWithAccess(
        useCallback(() => {
            downloadWeeklySummary({ from, to, ids, filters, columns, ...other });
        }, [from, to, ids, columns, filters, downloadWeeklySummary, other]),
        "timeSheet.canExport",
    );

    const downloadDetails = useActionWithAccess(
        useCallback(() => {
            downloadWeeklyDetails({ from, to, ids, filters, columns, ...other });
        }, [from, to, ids, columns, filters, downloadWeeklyDetails, other]),
        "timeSheet.canExportMyTimesheet",
    );

    return { downloadSummary, downloadDetails };
}
